export const flagAuditoriaOptions = [
    {
        value: true,
        label: 'Sim'
    },
    {
        value: false,
        label: 'Não'
    },
];